// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-blue-small/banner-blue-small.component.scss
// module id = 121
// module chunks = 0